var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21, _rect22, _rect23, _rect24, _rect25, _rect26, _rect27, _rect28, _rect29, _rect30, _rect31, _rect32, _rect33, _rect34, _rect35, _rect36, _rect37, _rect38, _rect39, _rect40, _rect41, _rect42, _rect43, _rect44, _rect45, _rect46, _rect47, _rect48, _rect49, _rect50, _rect51, _rect52, _rect53, _rect54, _rect55, _rect56, _rect57, _rect58, _rect59, _rect60, _rect61, _rect62, _rect63, _rect64, _rect65, _rect66, _rect67, _rect68, _rect69, _rect70, _rect71, _rect72, _rect73, _rect74, _rect75, _rect76, _rect77, _rect78, _rect79, _rect80, _rect81, _rect82, _rect83, _rect84, _rect85, _rect86, _rect87, _rect88, _rect89, _rect90, _rect91, _rect92, _rect93, _rect94, _rect95, _rect96, _rect97, _rect98, _rect99, _rect100, _rect101, _rect102, _rect103, _rect104;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgShape5(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 488,
    height: 454,
    viewBox: "0 0 488 454",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 54,
    y: 16,
    width: 4,
    height: 4,
    fill: "#A29898"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 360,
    y: 16,
    width: 4,
    height: 4,
    fill: "#A29898"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 162,
    y: 16,
    width: 4,
    height: 4,
    fill: "#A29898"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 306,
    y: 16,
    width: 4,
    height: 4,
    fill: "#A29898"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 108,
    y: 16,
    width: 4,
    height: 4,
    fill: "#A29898"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    y: 16,
    width: 4,
    height: 4,
    fill: "#A29898"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 414,
    y: 16,
    width: 4,
    height: 4,
    fill: "#A29898"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 216,
    y: 16,
    width: 4,
    height: 4,
    fill: "#A29898"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 270,
    y: 16,
    width: 4,
    height: 4,
    fill: "#A29898"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 72,
    y: 16,
    width: 4,
    height: 4,
    fill: "#A29898"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 378,
    y: 16,
    width: 4,
    height: 4,
    fill: "#A29898"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 180,
    y: 16,
    width: 4,
    height: 4,
    fill: "#A29898"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 324,
    y: 16,
    width: 4,
    height: 4,
    fill: "#A29898"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 126,
    y: 16,
    width: 4,
    height: 4,
    fill: "#A29898"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 16,
    width: 4,
    height: 4,
    fill: "#A29898"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 432,
    y: 16,
    width: 4,
    height: 4,
    fill: "#A29898"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 450,
    y: 16,
    width: 4,
    height: 4,
    fill: "#A29898"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 234,
    y: 16,
    width: 4,
    height: 4,
    fill: "#A29898"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 288,
    y: 16,
    width: 4,
    height: 4,
    fill: "#A29898"
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 90,
    y: 16,
    width: 4,
    height: 4,
    fill: "#A29898"
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 396,
    y: 16,
    width: 4,
    height: 4,
    fill: "#A29898"
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    x: 198,
    y: 16,
    width: 4,
    height: 4,
    fill: "#A29898"
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    x: 342,
    y: 16,
    width: 4,
    height: 4,
    fill: "#A29898"
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    x: 144,
    y: 16,
    width: 4,
    height: 4,
    fill: "#A29898"
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    x: 36,
    y: 16,
    width: 4,
    height: 4,
    fill: "#A29898"
  })), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    x: 252,
    y: 16,
    width: 4,
    height: 4,
    fill: "#A29898"
  })), _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    x: 54,
    width: 4,
    height: 4,
    fill: "#A29898"
  })), _rect28 || (_rect28 = /*#__PURE__*/React.createElement("rect", {
    x: 360,
    width: 4,
    height: 4,
    fill: "#A29898"
  })), _rect29 || (_rect29 = /*#__PURE__*/React.createElement("rect", {
    x: 162,
    width: 4,
    height: 4,
    fill: "#A29898"
  })), _rect30 || (_rect30 = /*#__PURE__*/React.createElement("rect", {
    x: 306,
    width: 4,
    height: 4,
    fill: "#A29898"
  })), _rect31 || (_rect31 = /*#__PURE__*/React.createElement("rect", {
    x: 108,
    width: 4,
    height: 4,
    fill: "#A29898"
  })), _rect32 || (_rect32 = /*#__PURE__*/React.createElement("rect", {
    width: 4,
    height: 4,
    fill: "#A29898"
  })), _rect33 || (_rect33 = /*#__PURE__*/React.createElement("rect", {
    x: 414,
    width: 4,
    height: 4,
    fill: "#A29898"
  })), _rect34 || (_rect34 = /*#__PURE__*/React.createElement("rect", {
    x: 216,
    width: 4,
    height: 4,
    fill: "#A29898"
  })), _rect35 || (_rect35 = /*#__PURE__*/React.createElement("rect", {
    x: 270,
    width: 4,
    height: 4,
    fill: "#A29898"
  })), _rect36 || (_rect36 = /*#__PURE__*/React.createElement("rect", {
    x: 72,
    width: 4,
    height: 4,
    fill: "#A29898"
  })), _rect37 || (_rect37 = /*#__PURE__*/React.createElement("rect", {
    x: 378,
    width: 4,
    height: 4,
    fill: "#A29898"
  })), _rect38 || (_rect38 = /*#__PURE__*/React.createElement("rect", {
    x: 180,
    width: 4,
    height: 4,
    fill: "#A29898"
  })), _rect39 || (_rect39 = /*#__PURE__*/React.createElement("rect", {
    x: 324,
    width: 4,
    height: 4,
    fill: "#A29898"
  })), _rect40 || (_rect40 = /*#__PURE__*/React.createElement("rect", {
    x: 126,
    width: 4,
    height: 4,
    fill: "#A29898"
  })), _rect41 || (_rect41 = /*#__PURE__*/React.createElement("rect", {
    x: 18,
    width: 4,
    height: 4,
    fill: "#A29898"
  })), _rect42 || (_rect42 = /*#__PURE__*/React.createElement("rect", {
    x: 432,
    width: 4,
    height: 4,
    fill: "#A29898"
  })), _rect43 || (_rect43 = /*#__PURE__*/React.createElement("rect", {
    x: 450,
    width: 4,
    height: 4,
    fill: "#A29898"
  })), _rect44 || (_rect44 = /*#__PURE__*/React.createElement("rect", {
    x: 234,
    width: 4,
    height: 4,
    fill: "#A29898"
  })), _rect45 || (_rect45 = /*#__PURE__*/React.createElement("rect", {
    x: 288,
    width: 4,
    height: 4,
    fill: "#A29898"
  })), _rect46 || (_rect46 = /*#__PURE__*/React.createElement("rect", {
    x: 90,
    width: 4,
    height: 4,
    fill: "#A29898"
  })), _rect47 || (_rect47 = /*#__PURE__*/React.createElement("rect", {
    x: 396,
    width: 4,
    height: 4,
    fill: "#A29898"
  })), _rect48 || (_rect48 = /*#__PURE__*/React.createElement("rect", {
    x: 198,
    width: 4,
    height: 4,
    fill: "#A29898"
  })), _rect49 || (_rect49 = /*#__PURE__*/React.createElement("rect", {
    x: 342,
    width: 4,
    height: 4,
    fill: "#A29898"
  })), _rect50 || (_rect50 = /*#__PURE__*/React.createElement("rect", {
    x: 144,
    width: 4,
    height: 4,
    fill: "#A29898"
  })), _rect51 || (_rect51 = /*#__PURE__*/React.createElement("rect", {
    x: 36,
    width: 4,
    height: 4,
    fill: "#A29898"
  })), _rect52 || (_rect52 = /*#__PURE__*/React.createElement("rect", {
    x: 252,
    width: 4,
    height: 4,
    fill: "#A29898"
  })), _rect53 || (_rect53 = /*#__PURE__*/React.createElement("rect", {
    x: 472,
    y: 54,
    width: 4,
    height: 4,
    transform: "rotate(90 472 54)",
    fill: "#A29898"
  })), _rect54 || (_rect54 = /*#__PURE__*/React.createElement("rect", {
    x: 472,
    y: 360,
    width: 4,
    height: 4,
    transform: "rotate(90 472 360)",
    fill: "#A29898"
  })), _rect55 || (_rect55 = /*#__PURE__*/React.createElement("rect", {
    x: 472,
    y: 162,
    width: 4,
    height: 4,
    transform: "rotate(90 472 162)",
    fill: "#A29898"
  })), _rect56 || (_rect56 = /*#__PURE__*/React.createElement("rect", {
    x: 472,
    y: 306,
    width: 4,
    height: 4,
    transform: "rotate(90 472 306)",
    fill: "#A29898"
  })), _rect57 || (_rect57 = /*#__PURE__*/React.createElement("rect", {
    x: 472,
    y: 108,
    width: 4,
    height: 4,
    transform: "rotate(90 472 108)",
    fill: "#A29898"
  })), _rect58 || (_rect58 = /*#__PURE__*/React.createElement("rect", {
    x: 472,
    width: 4,
    height: 4,
    transform: "rotate(90 472 0)",
    fill: "#A29898"
  })), _rect59 || (_rect59 = /*#__PURE__*/React.createElement("rect", {
    x: 472,
    y: 414,
    width: 4,
    height: 4,
    transform: "rotate(90 472 414)",
    fill: "#A29898"
  })), _rect60 || (_rect60 = /*#__PURE__*/React.createElement("rect", {
    x: 472,
    y: 216,
    width: 4,
    height: 4,
    transform: "rotate(90 472 216)",
    fill: "#A29898"
  })), _rect61 || (_rect61 = /*#__PURE__*/React.createElement("rect", {
    x: 472,
    y: 270,
    width: 4,
    height: 4,
    transform: "rotate(90 472 270)",
    fill: "#A29898"
  })), _rect62 || (_rect62 = /*#__PURE__*/React.createElement("rect", {
    x: 472,
    y: 72,
    width: 4,
    height: 4,
    transform: "rotate(90 472 72)",
    fill: "#A29898"
  })), _rect63 || (_rect63 = /*#__PURE__*/React.createElement("rect", {
    x: 472,
    y: 378,
    width: 4,
    height: 4,
    transform: "rotate(90 472 378)",
    fill: "#A29898"
  })), _rect64 || (_rect64 = /*#__PURE__*/React.createElement("rect", {
    x: 472,
    y: 180,
    width: 4,
    height: 4,
    transform: "rotate(90 472 180)",
    fill: "#A29898"
  })), _rect65 || (_rect65 = /*#__PURE__*/React.createElement("rect", {
    x: 472,
    y: 324,
    width: 4,
    height: 4,
    transform: "rotate(90 472 324)",
    fill: "#A29898"
  })), _rect66 || (_rect66 = /*#__PURE__*/React.createElement("rect", {
    x: 472,
    y: 126,
    width: 4,
    height: 4,
    transform: "rotate(90 472 126)",
    fill: "#A29898"
  })), _rect67 || (_rect67 = /*#__PURE__*/React.createElement("rect", {
    x: 472,
    y: 18,
    width: 4,
    height: 4,
    transform: "rotate(90 472 18)",
    fill: "#A29898"
  })), _rect68 || (_rect68 = /*#__PURE__*/React.createElement("rect", {
    x: 472,
    y: 432,
    width: 4,
    height: 4,
    transform: "rotate(90 472 432)",
    fill: "#A29898"
  })), _rect69 || (_rect69 = /*#__PURE__*/React.createElement("rect", {
    x: 472,
    y: 450,
    width: 4,
    height: 4,
    transform: "rotate(90 472 450)",
    fill: "#A29898"
  })), _rect70 || (_rect70 = /*#__PURE__*/React.createElement("rect", {
    x: 472,
    y: 234,
    width: 4,
    height: 4,
    transform: "rotate(90 472 234)",
    fill: "#A29898"
  })), _rect71 || (_rect71 = /*#__PURE__*/React.createElement("rect", {
    x: 472,
    y: 288,
    width: 4,
    height: 4,
    transform: "rotate(90 472 288)",
    fill: "#A29898"
  })), _rect72 || (_rect72 = /*#__PURE__*/React.createElement("rect", {
    x: 472,
    y: 90,
    width: 4,
    height: 4,
    transform: "rotate(90 472 90)",
    fill: "#A29898"
  })), _rect73 || (_rect73 = /*#__PURE__*/React.createElement("rect", {
    x: 472,
    y: 396,
    width: 4,
    height: 4,
    transform: "rotate(90 472 396)",
    fill: "#A29898"
  })), _rect74 || (_rect74 = /*#__PURE__*/React.createElement("rect", {
    x: 472,
    y: 198,
    width: 4,
    height: 4,
    transform: "rotate(90 472 198)",
    fill: "#A29898"
  })), _rect75 || (_rect75 = /*#__PURE__*/React.createElement("rect", {
    x: 472,
    y: 342,
    width: 4,
    height: 4,
    transform: "rotate(90 472 342)",
    fill: "#A29898"
  })), _rect76 || (_rect76 = /*#__PURE__*/React.createElement("rect", {
    x: 472,
    y: 144,
    width: 4,
    height: 4,
    transform: "rotate(90 472 144)",
    fill: "#A29898"
  })), _rect77 || (_rect77 = /*#__PURE__*/React.createElement("rect", {
    x: 472,
    y: 36,
    width: 4,
    height: 4,
    transform: "rotate(90 472 36)",
    fill: "#A29898"
  })), _rect78 || (_rect78 = /*#__PURE__*/React.createElement("rect", {
    x: 472,
    y: 252,
    width: 4,
    height: 4,
    transform: "rotate(90 472 252)",
    fill: "#A29898"
  })), _rect79 || (_rect79 = /*#__PURE__*/React.createElement("rect", {
    x: 488,
    y: 54,
    width: 4,
    height: 4,
    transform: "rotate(90 488 54)",
    fill: "#A29898"
  })), _rect80 || (_rect80 = /*#__PURE__*/React.createElement("rect", {
    x: 488,
    y: 360,
    width: 4,
    height: 4,
    transform: "rotate(90 488 360)",
    fill: "#A29898"
  })), _rect81 || (_rect81 = /*#__PURE__*/React.createElement("rect", {
    x: 488,
    y: 162,
    width: 4,
    height: 4,
    transform: "rotate(90 488 162)",
    fill: "#A29898"
  })), _rect82 || (_rect82 = /*#__PURE__*/React.createElement("rect", {
    x: 488,
    y: 306,
    width: 4,
    height: 4,
    transform: "rotate(90 488 306)",
    fill: "#A29898"
  })), _rect83 || (_rect83 = /*#__PURE__*/React.createElement("rect", {
    x: 488,
    y: 108,
    width: 4,
    height: 4,
    transform: "rotate(90 488 108)",
    fill: "#A29898"
  })), _rect84 || (_rect84 = /*#__PURE__*/React.createElement("rect", {
    x: 488,
    width: 4,
    height: 4,
    transform: "rotate(90 488 0)",
    fill: "#A29898"
  })), _rect85 || (_rect85 = /*#__PURE__*/React.createElement("rect", {
    x: 488,
    y: 414,
    width: 4,
    height: 4,
    transform: "rotate(90 488 414)",
    fill: "#A29898"
  })), _rect86 || (_rect86 = /*#__PURE__*/React.createElement("rect", {
    x: 488,
    y: 216,
    width: 4,
    height: 4,
    transform: "rotate(90 488 216)",
    fill: "#A29898"
  })), _rect87 || (_rect87 = /*#__PURE__*/React.createElement("rect", {
    x: 488,
    y: 270,
    width: 4,
    height: 4,
    transform: "rotate(90 488 270)",
    fill: "#A29898"
  })), _rect88 || (_rect88 = /*#__PURE__*/React.createElement("rect", {
    x: 488,
    y: 72,
    width: 4,
    height: 4,
    transform: "rotate(90 488 72)",
    fill: "#A29898"
  })), _rect89 || (_rect89 = /*#__PURE__*/React.createElement("rect", {
    x: 488,
    y: 378,
    width: 4,
    height: 4,
    transform: "rotate(90 488 378)",
    fill: "#A29898"
  })), _rect90 || (_rect90 = /*#__PURE__*/React.createElement("rect", {
    x: 488,
    y: 180,
    width: 4,
    height: 4,
    transform: "rotate(90 488 180)",
    fill: "#A29898"
  })), _rect91 || (_rect91 = /*#__PURE__*/React.createElement("rect", {
    x: 488,
    y: 324,
    width: 4,
    height: 4,
    transform: "rotate(90 488 324)",
    fill: "#A29898"
  })), _rect92 || (_rect92 = /*#__PURE__*/React.createElement("rect", {
    x: 488,
    y: 126,
    width: 4,
    height: 4,
    transform: "rotate(90 488 126)",
    fill: "#A29898"
  })), _rect93 || (_rect93 = /*#__PURE__*/React.createElement("rect", {
    x: 488,
    y: 18,
    width: 4,
    height: 4,
    transform: "rotate(90 488 18)",
    fill: "#A29898"
  })), _rect94 || (_rect94 = /*#__PURE__*/React.createElement("rect", {
    x: 488,
    y: 432,
    width: 4,
    height: 4,
    transform: "rotate(90 488 432)",
    fill: "#A29898"
  })), _rect95 || (_rect95 = /*#__PURE__*/React.createElement("rect", {
    x: 488,
    y: 450,
    width: 4,
    height: 4,
    transform: "rotate(90 488 450)",
    fill: "#A29898"
  })), _rect96 || (_rect96 = /*#__PURE__*/React.createElement("rect", {
    x: 488,
    y: 234,
    width: 4,
    height: 4,
    transform: "rotate(90 488 234)",
    fill: "#A29898"
  })), _rect97 || (_rect97 = /*#__PURE__*/React.createElement("rect", {
    x: 488,
    y: 288,
    width: 4,
    height: 4,
    transform: "rotate(90 488 288)",
    fill: "#A29898"
  })), _rect98 || (_rect98 = /*#__PURE__*/React.createElement("rect", {
    x: 488,
    y: 90,
    width: 4,
    height: 4,
    transform: "rotate(90 488 90)",
    fill: "#A29898"
  })), _rect99 || (_rect99 = /*#__PURE__*/React.createElement("rect", {
    x: 488,
    y: 396,
    width: 4,
    height: 4,
    transform: "rotate(90 488 396)",
    fill: "#A29898"
  })), _rect100 || (_rect100 = /*#__PURE__*/React.createElement("rect", {
    x: 488,
    y: 198,
    width: 4,
    height: 4,
    transform: "rotate(90 488 198)",
    fill: "#A29898"
  })), _rect101 || (_rect101 = /*#__PURE__*/React.createElement("rect", {
    x: 488,
    y: 342,
    width: 4,
    height: 4,
    transform: "rotate(90 488 342)",
    fill: "#A29898"
  })), _rect102 || (_rect102 = /*#__PURE__*/React.createElement("rect", {
    x: 488,
    y: 144,
    width: 4,
    height: 4,
    transform: "rotate(90 488 144)",
    fill: "#A29898"
  })), _rect103 || (_rect103 = /*#__PURE__*/React.createElement("rect", {
    x: 488,
    y: 36,
    width: 4,
    height: 4,
    transform: "rotate(90 488 36)",
    fill: "#A29898"
  })), _rect104 || (_rect104 = /*#__PURE__*/React.createElement("rect", {
    x: 488,
    y: 252,
    width: 4,
    height: 4,
    transform: "rotate(90 488 252)",
    fill: "#A29898"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShape5);
export default __webpack_public_path__ + "static/media/shape-5.fb944586092dbb20db4f52942e488230.svg";
export { ForwardRef as ReactComponent };